import { api } from '@/services'

export async function deleteCartRequest(id: string) {
  try {
    const { data } = await api.post(`Cart/DeleteCart?${id}`)

    return { data }
  } catch (error) {
    console.error(error)
  }
}
